<template>
  <highcharts class="fit-highchart" :options="options" style="width: 100%" />
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { columnOptions } from '@/constants/chart-options';

export default {
  name: 'WSummaryColumnChart',
  props: {
    series: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      options: cloneDeep(columnOptions),
    };
  },
  watch: {
    series(value) {
      this.options.chart.height = '140px';
      this.options.series = value;
      this.options.xAxis = {
        type: 'datetime',
        tickInterval: 3600 * 1000,
        labels: {
          format: '{value:%H}시',
        },
      };
      this.options.tooltip = {
        headerFormat: '<b>{point.key}</b><br/>',
        xDateFormat: '%Y-%m-%d %H시',
        pointFormat: '{series.name}: {point.y}<br />',
        shared: true,
      };
      this.options.legend = false;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/node/summary/components/SummaryColumnChart.vue